import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import {QueryClientProvider,QueryClient} from "@tanstack/react-query";
import {LocalizationProvider } from '@mui/x-date-pickers';
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import it from 'date-fns/locale/it';
import {createTheme, ThemeProvider,} from "@mui/material";
import Sidebar from "./components/Sidebar";

const isIframe = window.self !== window.top;

const myTheme = createTheme({
  components: {
    // MuiInputLabel: {
    //    defaultProps: { shrink: true },
    //   },
    MuiTextField: {
       defaultProps: { InputLabelProps: { shrink: true }, },

    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& label': {
            fontSize: 16,
          },
        },
        input: {
          fontSize: 16,
        },
        listbox: {
           fontSize: 12,

        },
      },
    },
   },
  });

  const myThemeIframe = createTheme({
    components: {
      MuiTextField: {
        defaultProps: { InputLabelProps: { shrink: true }, },
      },
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            '& label': {
              fontSize: 16,
            },
          },
          input: {
            fontSize: 16,
          },
          listbox: {
             fontSize: 12,
          },
        },
      },
      MuiModal: {
        styleOverrides: {
          root: {
            overflow: 'hidden',
            backgroundColor: 'transparent',
            borderRadius: '1em',
            borderRight: '0px !important',
            boxShadow: 'none',       
          }
        }
      },
      MuiPaper: {
        styleOverrides: {
          elevation: {
            overflow: 'hidden',
            backgroundColor: 'transparent',
            //borderRadius: '1em',
            borderRight: '0px !important',
            boxShadow: 'none',       
          },
          rounded:  {
            overflow: 'hidden',
            backgroundColor: 'white'
          }
        },
      },
      MuiDialog: {
        styleOverrides: {
          container: {
            backgroundColor: 'alyceblue',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
          },
        },
      },
      MuiList: {
        styleOverrides: {
          root: {
            backgroundColor: 'rgba(255, 255, 255, 0.93)',
            borderRadius: '1em',
            marginRight: '2px',
          },
        },
      }
    }
  });

  

const queryClient = new QueryClient()
function App() {

//isIframe is used to determine if the application is running inside an iframe (al posto di true)
  return (
    <>
    <ThemeProvider theme={isIframe ? myThemeIframe : myTheme}>
     <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={it}>
      <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route path="*" element={<Navigate to="/app" replace />} />
          <Route path="/app/*" element={<Sidebar  open={open} />} />
        </Routes>
      </Router>
      </QueryClientProvider>
     </LocalizationProvider>
     </ThemeProvider>
    </>
  );
}

export default App;
